export default __webpack_public_path__ + "static/media/loading-videogames.fb6d37a2.gif";